module.exports = "/images/mastercard.svg";